"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelTable = exports.PanelList = exports.Panel = void 0;
var React = require("react");
var classNames = require("classnames");
var __1 = require("../");
var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: props.isOpen !== false
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    Panel.prototype.componentWillReceiveProps = function (nextProps) {
        if (typeof nextProps.isOpen === 'boolean' &&
            nextProps.isOpen !== this.props.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    };
    Panel.prototype.toggle = function () {
        var isOpen = !this.state.isOpen;
        this.setState({ isOpen: isOpen });
        if (this.props.onToggle) {
            this.props.onToggle(isOpen);
        }
        if (isOpen) {
            if (this.props.onOpen) {
                this.props.onOpen();
            }
        }
        else {
            if (this.props.onClose) {
                this.props.onClose();
            }
        }
    };
    Panel.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, headerButtons = _a.headerButtons, icon = _a.icon, footer = _a.footer, disableCollapse = _a.disableCollapse, children = _a.children, className = _a.className, style = _a.style, theme = _a.theme;
        var isOpen = this.state.isOpen;
        return (React.createElement("div", { className: classNames('sok-panel', 'sok-panel-theme-' + (theme || 'default'), { open: isOpen, 'disable-collapse': disableCollapse }, className), style: style },
            title && (React.createElement("header", { className: "sok-panel-header", onClick: function () { return !disableCollapse && _this.toggle(); } },
                React.createElement("h3", { className: "sok-panel-title" },
                    icon && React.createElement("span", { className: "sok-panel-icon" }, icon),
                    title),
                headerButtons,
                !disableCollapse && (React.createElement("button", { className: "sok-panel-toggle-button" }, isOpen ? (React.createElement(__1.Icon, { className: 'fa-chevron-down', prefix: 'far' })) : (React.createElement(__1.Icon, { className: 'fa-chevron-up', prefix: 'far' })))))),
            React.createElement(__1.Collapse, { collapsed: !isOpen },
                React.createElement("div", { className: "sok-panel-body" }, children),
                footer && React.createElement("footer", { className: "sok-panel-footer" }, footer))));
    };
    return Panel;
}(React.Component));
exports.Panel = Panel;
var PanelList = function (_a) {
    var className = _a.className, children = _a.children, borderCollapsed = _a.borderCollapsed, rest = __rest(_a, ["className", "children", "borderCollapsed"]);
    return (React.createElement("ul", __assign({ className: classNames('sok-panel-list', { 'border-collapse': borderCollapsed }, className) }, rest), children));
};
exports.PanelList = PanelList;
var PanelTable = function (_a) {
    var className = _a.className, children = _a.children, borderCollapsed = _a.borderCollapsed, rest = __rest(_a, ["className", "children", "borderCollapsed"]);
    return (React.createElement("table", __assign({ className: classNames('sok-panel-table', { 'border-collapse': borderCollapsed }, className) }, rest), children));
};
exports.PanelTable = PanelTable;
//# sourceMappingURL=index.js.map